import { ApiNewDokumentPowiazanyDalDto, EgibObject } from '@gk/gk-modules';
import { WorkspaceState } from '../../../../services/request-workspace-state/request-workspace-state.model';
import {
  DocumentationFormType,
  ExtendedApplicantRequest,
  ExtendedApplicantRequestDto,
} from '../../../../shared/base-new-request/base-new-request.model';
import { InvestorDetails } from '../../../../shared/investor-details/investor-details.model';
import { Shipping } from '../../../../shared/shipping-form/shipping-form.model';
import { PropertyUsage } from '../business-purposes-checkbox-control/business-purposes-checkbox-control.model';

export interface OCFCRNewRequestDto extends ExtendedApplicantRequestDto {
  InfoDodatkowe: string;
  Bonifikata99: boolean;
  LokalLubBudynekWylacznieDoPotrzebMieszkaniowych: boolean;
  NieruchomoscDoCelowProwadzeniaDzialalnosciCalosc: boolean;
  NieruchomoscDoCelowProwadzeniaDzialalnosciCzesc: boolean;
  ProcentCzesciPrzeznaczonejNaDzialalnosc: number;
}

export class OCFCRNewRequest extends ExtendedApplicantRequest {
  constructor(
    investorDetails: InvestorDetails,
    documentationForm: DocumentationFormType,
    shippingForm: Shipping,
    proxyDetailsCheckbox: boolean,
    proxyDetailsArray: InvestorDetails[],
    public comments: string,
    public propertyUsage: PropertyUsage,
    public discountConditions: boolean,
    public forHousingPurposes: boolean,
  ) {
    super(
      investorDetails,
      documentationForm,
      shippingForm,
      undefined,
      undefined,
      proxyDetailsCheckbox,
      proxyDetailsArray,
    );
  }

  static fromAppToApi(
    data: OCFCRNewRequest,
    issueRanges: string[],
    parcels: EgibObject[],
    buildings: EgibObject[],
    premises: EgibObject[],
    files: ApiNewDokumentPowiazanyDalDto[],
  ): OCFCRNewRequestDto {
    const isBusinessUsage = data.propertyUsage?.businessUsage;
    const isBusinessUsageFull = isBusinessUsage
      ? data.propertyUsage.businessUsageFull
      : false;
    const isBusinessUsagePart = isBusinessUsage
      ? data.propertyUsage.businessUsageFull === false
      : false;
    return {
      ...ExtendedApplicantRequest.mapCommonFields({
        data,
        issueRanges,
        files,
        parcels,
        buildings,
        premises,
      }),
      InfoDodatkowe: data.comments,
      NieruchomoscDoCelowProwadzeniaDzialalnosciCalosc: isBusinessUsageFull,
      NieruchomoscDoCelowProwadzeniaDzialalnosciCzesc: isBusinessUsagePart,
      ProcentCzesciPrzeznaczonejNaDzialalnosc: isBusinessUsagePart
        ? data.propertyUsage.businessUsageShare
        : null,
      Bonifikata99: data.discountConditions,
      LokalLubBudynekWylacznieDoPotrzebMieszkaniowych: data.forHousingPurposes,
    };
  }
}

export interface OCFCRNewRequestFormWorkspaceState extends WorkspaceState {
  formValue: OCFCRNewRequest;
  parcels: EgibObject[];
  issueRanges: string[];
  buildings: EgibObject[];
  premises: EgibObject[];
}
